import { render, staticRenderFns } from "./DetailsCourier.vue?vue&type=template&id=41f81b70"
import script from "./DetailsCourier.vue?vue&type=script&lang=js"
export * from "./DetailsCourier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports